import Vue from "vue";

//全局通用方法
import * as utils from "../utils";
utils.globalInit(utils);

//全局样式
import '../style/css.css'

//vant组件
import '../plugins/vant'
